export default "__VITE_ASSET__BzBJs66y__"